import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { Typography, Box } from "@mui/material";

const ContentCard = React.forwardRef(
    ({ title, link, subTitle, icon, children, onClick }, ref) => {
        const { classes } = useStyles();

        const Wrapper = link ? Link : "div";

        return (
            <Wrapper
                to={link}
                onClick={onClick}
                className={classes.linkWrapper}
                style={{ textDecoration: "none" }}
            >
                <Box className={classes.card}>
                    {icon && <div className={classes.iconWrapper}>{icon}</div>}

                    <Typography variant="h5" className={classes.title}>
                        {title}
                    </Typography>

                    <Typography variant="body2" className={classes.subTitle}>
                        {subTitle}
                    </Typography>

                    <Box mt={2}>{children}</Box>
                </Box>
            </Wrapper>
        );
    }
);

const useStyles = makeStyles({ name: "ContentCard" })((theme) => ({
    linkWrapper: {
        display: "block",
    },
    card: {
        position: "relative",
        borderRadius: "20px",
        padding: theme.spacing(4),
        textAlign: "center",
        background: "rgba(255,255,255,0.1)",
        backdropFilter: "blur(12px)",
        border: "2px solid transparent",
        transition: "all 0.3s ease",

        "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            borderRadius: "20px",
            padding: "2px", // thickness of the border
            background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            WebkitMaskComposite: "xor",
            maskComposite: "exclude",
            opacity: 0,
            transition: "opacity 0.3s ease",
            zIndex: -1,
        },

        "&:hover": {
            transform: "translateY(-6px) scale(1.02)",
            boxShadow: "0 12px 32px rgba(0,0,0,0.25)",
            "&::before": {
                opacity: 1,
            },
        },
    },
    iconWrapper: {
        width: 56,
        height: 56,
        margin: "0 auto 16px auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
        color: "#fff",
        fontSize: 28,
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    },
    title: {
        fontWeight: 700,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    subTitle: {
        fontSize: "0.95rem",
        color: theme.palette.text.secondary,
    },
}));

export default ContentCard;
